type Vec = [x: number, y: number];

export const getVector = (element: HTMLElement, [sX, sY]: Vec = [0.5, 0.5]): Vec => {
    const { x, y, width, height } = element.getBoundingClientRect();
    return [x + sX * width + window.scrollX, y + sY * height + window.scrollY];
};
